<template>
  <div>
    <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
      <el-tab-pane
        v-for="(item, index) in itemData.tabs"
        :key="index"
        :label="item.name"
        :name="item.index"
      >
      </el-tab-pane>
      <el-row   v-show="'0' == activeName || '1' == activeName">
        <!--树形-->
        <el-col :span="7">
          <el-tree :data="depList" lazy :props="defaultProps" @node-click="handleNodeClick"></el-tree>
        </el-col>
        <!--表格-->
        <el-col :span="17">
          <template>
            <el-table
              ref="multipleTable"
              :data="tableData"
              tooltip-effect="dark"
              style="width: 100%"
              :row-key="getRowKeys"
              @select="selectClick"
              max-height="400"
              @select-all="selectAll"
            >
            <el-table-column :reserve-selection="true" type="selection" width="55"  >
            </el-table-column>
            <el-table-column prop="name" >
            </el-table-column>
              <!-- <el-table-column
                v-for="(item, index) in tabHead"
                :prop="item.id"
                :label="item.name"
                :key="index"
              ></el-table-column> -->
            </el-table>
          </template>
        </el-col>
      </el-row>
     
    </el-tabs>
    <div>
      <div>选中:</div>
      <div class="seleDiv">
        <a href="javascript:" v-show="'0' == activeName || '1' == activeName" v-for="(item, index) in selectTableData" :key="index">
          {{ item.userName != 'undefined' && item.userName != '' && item.userName != null && item.userName != 'null' ?item.userName:item.userName}}
          <span class="del el-icon-close" @click="delData(index)"></span>
        </a>
        <a href="javascript:" v-show="('2' == activeName || '3' == activeName) && selectedName != 'undefined' && selectedName != '' && selectedName != null && selectedName != 'null'">
          {{ selectedName }}
          <span class="del el-icon-close" @click="delData()"></span>
        </a>
        
      </div>
    </div>
    <div class="foot">
      <el-button type="primary" @click="submit">确定</el-button>
      <!-- <el-button type="primary" @click="$parent.$parent.selectOff = false">取消</el-button> -->
    </div>
  </div>
</template>
<style scoped>
.foot {
  text-align: center;
  padding: 6px 10px;
}
.seleDiv {
  border: 1px solid #ddd;
  min-height: 100px;
  padding: 5px;
  white-space: nowrap;
}
.seleDiv a {
  color: #666;
  position: relative;
  padding: 5px 14px;
}
.seleDiv .del {
  position: absolute;
  top: 0px;
  right: 0px;
}
</style>
<script>
// import { reqUrls } from "@/assets/js/selectperson.js";
// import { userReq } from '@/assets/js/public'; 
import { flowbles } from '@/api/flowble'
export default {
  data() {
    return {
      activeName: null,
      data: [],
      nodeId: "", //当前节点id
      toggle: true, //判断点击是从选中来，还是table勾选框中的来的
      tabHead: [
        {
          label: "名称",
          prop: "realname",
        },
      ],
      // tabUserHead: [
      //   {
      //     label: "用户名",
      //     prop: "realname",
      //   },
      // ],
      // tabPosHead: [
      //   {
      //     label: "岗位名",
      //     prop: "postName",
      //   },
      // ],
      systemPosts:[],
      selected: true, //判断是选中还是取消
      selectNow: {}, //表格中的当前勾选项
      tableData: [],
      selectTableData: [],
      selectedVal:"",
      selectedName:"",
      defaultProps: {
        //树的默认配置
        // children: "children",
        label: "name",
      },
      depList:[]
    };
  },
  // 初始化加载
  mounted() {
    this.init();
    this.reload();
    this.loadData();
  },
  props: ["itemData", "selectOff"],
  created() {
    // this.itemData.getTree = this.itemData.getTree? this.itemData.getTree : reqUrls.getTree;
    this.itemData.getDepTree = this.itemData.getDepTree? this.itemData.getDepTree: flowbles.getDep;
    this.itemData.getDepUser = this.itemData.getDepUser ? this.itemData.getDepUser: flowbles.getUser;
    // this.itemData.getDepPos = this.itemData.getDepPos? this.itemData.getDepPos: reqUrls.getDepPos;    
  },
  methods: {
    init() {      
      // this.activeName = this.itemData.tabFouce;
      this.activeName="0";
      this.loadPost()
    },
    // 加载初始数据
    loadData(){
        let _this = this;
        console.log('load')
        this.$emit("initLoadData",(excuteRoleModel)=>{
            if(excuteRoleModel){
                if("0" === _this.activeName 
                    || "1" === _this.activeName ){
                    if(excuteRoleModel.excuteDatas){
                      _this.selectTableData = excuteRoleModel.excuteDatas;
                    }
                }// 系统职位 
                else {
                  _this.selectedVal = excuteRoleModel.sysPostCode;
                }
            }
        });
        
    },
    // 删除数据
    delData(arrayIndex) {   
      if("0" == this.activeName 
        || "1" == this.activeName){
            // 删除选中表格   
            if(typeof this.selectTableData != 'undefined'){
              let tableRow = this.selectTableData[arrayIndex].tableRow;
              if(tableRow){
                this.$refs.multipleTable.toggleRowSelection(tableRow,false);
              }
              this.selectTableData.splice(arrayIndex,1);
            }
      }// 设置数据
       else {
          this.selectedVal = null;
          this.selectedName = null;
      }
    },
    /*
     * @parm{url,parm,id}接口地址，参数，id
     */
    selGeNode(url, parm, id) {
      console.log(parm,"parm")
          try {
              //是否第一懒加载      
              let orgData = {};
              if(parm){
                return new Promise((resolve, reject) => {
                  this.axios.get(url,orgData).then(res=>{
                    resolve(res.data.data);
                  })
                });
              }
              
          }catch(e){
              console.log("树形节点选择:"+e);
          }
    },
    // 当用户手动勾选数据行的 Checkbox 时触发的事件
    // 选中的行selection
    selectClick(selection, row) {
      let _this = this;
      if(selection){
          let selectionIndex = -1;
          if( "0" == _this.activeName ){
            let tTableDataUserId = row.id;
            selectionIndex = selection.findIndex(selectiont => selectiont.id === tTableDataUserId);
          }
          if( "1" == _this.activeName ){
              let tTableDataPostId = row.id;
              selectionIndex = selection.findIndex(selectiont => selectiont.id === tTableDataPostId);
          }
          if(-1 != selectionIndex){
              // 选中
              this.selectedData(row);
          }
           // 清除数据
         this.clearSelectedData(selection);
      }
       
    },
    // 当用户手动勾选全选 Checkbox 时触发的事件
    selectAll(selection) {
      console.log(selection)
      let arr = []
      for(let i in selection) {
        let isSame = false
        for(let j in this.selectTableData) {
          if(this.selectTableData[j].userId === selection[i].id) {
            isSame = true
            break
          }
        }
        if(!isSame) {
          arr.push(selection[i])
        }
      }
      console.log(this.selectTableData)
      if(arr){
          arr.forEach(selectionRow => {
            // 选中
              this.selectedData(selectionRow);
          });
          // 清除数据
         this.clearSelectedData(arr);
      }
    },
    getRowKeys(row) {
      return row.id;
    },
    // 清楚选中列表
    clearSelectedData(selection){
        try {
            let _this = this;
            if(typeof this.selectTableData != 'undefined' 
              && this.selectTableData.length > 0){
                let selectTableDataLength  = this.selectTableData.length;
                for(let tableDataIndex = (selectTableDataLength-1);tableDataIndex >= 0;tableDataIndex--){
                  try {
                        let tTableData = this.selectTableData[tableDataIndex];
                        let selectionIndex = -1;
                        if( "0" == _this.activeName ){
                          let tTableDataUserId = tTableData.userId;
                          selectionIndex = selection.findIndex(selectiont => selectiont.userId === tTableDataUserId);
                        }
                        if( "1" == _this.activeName ){
                            let tTableDataPostId = tTableData.postId;
                            selectionIndex = selection.findIndex(selectiont => selectiont.id === tTableDataPostId);
                        }
                        if(selectionIndex === -1 
                              && tTableData.activeIndex === _this.activeName
                              &&  tTableData.nodeId === _this.nodeId){
                          this.selectTableData.splice(tableDataIndex,1);
                        }
                      }catch(e){
                      console.log('清洗数据'+e);
                    }
                }
            }
        }catch(e){
          console.log(''+e);
        }
    },
    // 设置选中
    selectedCheckBox(){
      try {
          let _this = this;
          if(this.tableData){
             this.tableData.forEach((tableRow)=>{
                let selectTableDataIndex = -1;
                    if( "0" == _this.activeName ){
                      let tTableDataUserId = tableRow.id;
                      selectTableDataIndex = _this.selectTableData.findIndex(selectTableDatat => selectTableDatat.id === tTableDataUserId);
                    }
                    if( "1" == _this.activeName ){
                        let tTableDataPostId = tableRow.id;
                        selectTableDataIndex = _this.selectTableData.findIndex(selectTableDatat => selectTableDatat.postId === tTableDataPostId);
                    }
                    // 设置选中
                  if(selectTableDataIndex != -1){
                    this.$refs.multipleTable.toggleRowSelection(tableRow,true);
                  }
             });
          }
      }catch(e){
        console.log('设置选中',e);
      }
    },
    // 树形点击
    handleNodeClick(node) {
      //树形的点击事件
      let nodeId = node ? node.id : "";
      this.nodeId = nodeId;
      let data = {
        id: nodeId,
        curPage:1,
        limit: 20
      };
      // let _this = this;
       // 人员
      if (this.activeName == "0") {
          this.loadUser(data);
      }
    },
    // 选中值
    selectedData(itemData){
        // 人员/岗位
        if("0" == this.activeName || "1" == this.activeName){
            // 去重
             let selectTableDataIndex = -1;
             if( "0" == this.activeName ){
                let tTableDataUserId = itemData.id;
                selectTableDataIndex = this.selectTableData.findIndex(selectTableDatat => selectTableDatat.id === tTableDataUserId);
                // console.log(selectTableDataIndex)
              }
              if( "1" == this.activeName ){
                  let tTableDataPostId = itemData.id;
                  selectTableDataIndex = this.selectTableData.findIndex(selectTableDatat => selectTableDatat.postId === tTableDataPostId);
                  
              }
              if(-1 === selectTableDataIndex){
                    // let obj = {
                    //     orgId:itemData.orgId,
                    //     orgName:itemData.orgName,
                    //     depId:itemData.depId,
                    //     depName:itemData.depName,
                    //     userId:itemData.id,
                    //     name:itemData.name,
                    //     // postId:"0"==this.activeName?itemData.postId:itemData.id,
                    //     postName:itemData.postName,
                    //     tableRow:itemData,
                    //     activeIndex:this.activeName,
                    //     nodeId:this.nodeId
                    //   };

                    let obj = {
                       userId:itemData.id,
                       userName:itemData.name
                     };
                    this.selectTableData.push(obj);
                    console.log(obj,"000")
              }
        } // 系统职位
         else {
            this.selectedVal = itemData;
        }
        
    },
    loadNode(node, resolve) {
      console.log(node,"node")
      //树形懒加载
      if (node.level == 0) {
        const ASYNC = async () => {
          let treeData = await this.selGeNode(this.itemData.getDepTree, true);
          resolve(treeData);
        };
        ASYNC();
      } else if (node.level > 0 && node.level < 3) {
        const ASYNC = async () => {
          let treeData = await this.selGeNode(
            this.itemData.getDepTree,
            false,
            node.data.id
          );
          resolve(treeData);
        };
        ASYNC();
      } else {
        const ASYNC = async () => {
          let treeData = await this.selGeNode(
            this.itemData.getDepTree,
            false,
            node.data.id
          );
          resolve(treeData);
        };
        ASYNC();
      }
    },
    // 刷新数据
    reload(){
      let data = {id: this.nodeId};
      // 人员
      if (this.activeName == "0") {
          this.loadUser(data);
      } 
     
    },
    handleClick(tab, event) {
      if("0" === this.activeName 
          || "1" == this.activeName){
            this.$refs.multipleTable.clearSelection();
          this.selectTableData = [];
      } else {
        this.selectedVal = null;
        this.selectedName = null;
      }
      //选项卡切换
      this.$emit("changeGroupRoleType",this.activeName);
      this.reload();
    },
    // 加载人员
    loadUser(data,successBack){
        try {
            // this.tabHead = [...this.tabUserHead]; 
            let url = `${this.itemData.getDepUser}?id=${data.id}&curPage=${data.curPage}&limit=${data.limit}`
            this.axios.post(url, {}).then(res=>{
              if(res.data.data){
                console.log(res,"000")
                this.tableData = res.data.data;
                this.selectedCheckBox();
              }
              
            })
        }catch(e){
          console.log("人员加载异常"+e);
        }
    },
    
   // 加载部门
    loadPost(data,successBack){
      try{
           this.axios.get(this.itemData.getDepTree,{}).then(res=>{
              this.depList = res.data.data;
            })
      }catch(e){
        console.log("部门加载异常"+e);
      }
    },
    // 保存选中角色
    submit() {
      if("0" === this.activeName 
          || "1" == this.activeName){
          this.$emit("personSubmit",this.selectTableData);
      } else {
          this.$emit("personSubmit",this.selectedVal);
      }
    },
  },
  watch: {
    selectOff(newVal, oldVal) {
      if(newVal === true) {
        this.loadData()
      }
    }
  },
};
</script>
